module.exports = __webpack_public_path__ + "img/Abstract-link-support.e0ca642f.svg";